module.exports = __webpack_public_path__ + "assets/img/search.a129a2d5.svg";